import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/downloads/client/DownloadsClient.tsx");
